import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'proxy-polyfill/proxy.min.js';
import './scss/styles.scss';
import 'react-toastify/scss/main.scss';
import React from "react";
import ReactDOM from "react-dom";
import { removeDebugLogs } from './util/remove-debug-logs.js';
import { EmbedApplicationBootstrap } from './embed-application-bootstrap.js';
import { ApplicationBootstrap } from './application-bootstrap.js';

removeDebugLogs();

/**
 * Decide si se monta la aplicacion completa o la experiencia embebible.
 *
 * Las rutas `/embed/...` estan pensadas para cargarse de forma aislada,
 * por ejemplo dentro de un iframe o una pagina externa.
 */
const isEmbedApplication = window.location.pathname.startsWith('/embed');

ReactDOM.render(
  <React.StrictMode>
    {isEmbedApplication ? <EmbedApplicationBootstrap /> : <ApplicationBootstrap />}
  </React.StrictMode>
  , document.getElementById("app"));

